import React from 'react';
import FeatureCards from "../../components/FeatureCards/FeatureCards";
import CTA from "../../components/Constant/cta/CTA";
import TimelineSection from "../../components/TimelineSection/TimelineSection";
import WhySection from "../../components/WhySection/WhySection";
import LocationTimeline from "../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../components/IntroSection/IntroSection";
import FAQList from "../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../components/ServiceCards/ServiceCards ";

export default function ResidencyInvestmentCyprus() {

    return (
        <main className='main'>
            <IntroSection
                title="Residency & Investment – Cyprus"
                subtitle="Secure EU Residency Through Strategic Investment"
                description="Cyprus offers a range of residency and investment programs, making it one of the most accessible and attractive EU destinations for international investors. With its favorable tax regime (12.5%), strong banking system, and high quality of life, Cyprus is a top choice for entrepreneurs, digital nomads, retirees, and families."
                badges={[
                    "Permanent Residency (Fast Track)",
                    "Temporary Residence Permits",
                    "Golden Visa Investment Options",
                    "EU Access & Lifestyle"
                ]}
                buttonText="Request a Cyprus Residency Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../assets/images/residency-passport/residency-investment-cyprus-hero.png")}
                imageAlt="Cyprus Residency & Investment"
            />


            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Cyprus for Residency?'
                        blocks={[
                            {
                                items: [
                                    { title: "EU Member State", text: "Live, study, and travel freely within the EU." },
                                    { title: "Attractive Tax Regime", text: "12.5% corporate tax, Non-Dom tax regime, 0% on dividends." },
                                    { title: "Business Friendly", text: "English-speaking professionals, global banking access." },
                                    { title: "Lifestyle", text: "Mediterranean climate, safety, healthcare, and education." },
                                    { title: "Strategic Location", text: "Gateway between EU, Middle East, and Asia." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Cyprus Residency by Investment Options"
                        blocks={[
                            {
                                title: "1. Fast Track Permanent Residency (Category F / Golden Visa)",
                                items: [
                                    { text: "Investment in real estate of minimum €300,000 (new property only)." },
                                    { text: "Proof of stable income from abroad (€30,000+/year, plus €5,000 per dependent)." },
                                    { text: "Processing time: 2–4 months." },
                                    { text: "Covers spouse and children (up to 25 if dependent)." },
                                    { text: "Permanent Residency = indefinite validity, with no renewal needed." }
                                ]
                            },
                            {
                                title: "2. Temporary Residence (Pink Slip)",
                                items: [
                                    { text: "For non-EU citizens renting property or working in Cyprus." },
                                    { text: "Renewable annually." },
                                    { text: "Suitable for retirees and digital nomads." }
                                ]
                            },
                            {
                                title: "3. Business/Investor Residency",
                                items: [
                                    { text: "Incorporate a Cyprus company and obtain a residence permit as Director/Shareholder." },
                                    { text: "Must show office lease, employment of locals, and business activity." },
                                    { text: "Ideal for entrepreneurs and fintech/startup founders." }
                                ]
                            },
                            {
                                title: "4. Citizenship by Naturalization (Long-Term Pathway)",
                                items: [
                                    { text: "After 7 years of legal residence, foreigners may apply for citizenship." },
                                    { text: "Reduced to 5 years if actively contributing to Cyprus society." },
                                    { text: "Citizenship grants full EU passport rights." },
                                    { text: "Note: the previous Cyprus Golden Passport Program has been suspended, but long-term naturalization remains." }
                                ]
                            }
                        ]}
                    />

                    <ServiceCards
                        title="Benefits of Cyprus Residency & Investment"
                        services={[
                            { title: "EU Lifestyle & Mobility", text: "Live in Cyprus, travel freely in Schengen." },
                            { title: "Business Hub", text: "Ideal for forex, fintech, crypto, and offshore structures." },
                            { title: "Banking Access", text: "Residency supports account opening in EU banks." },
                            { title: "Real Estate Investment", text: "Strong property market with appreciation potential." },
                            { title: "Family-Friendly", text: "High education standards, healthcare, and safety." }
                        ]}
                    />

                    <DetailsSection
                        title="Residency Application Process"
                        items={
                            [
                                { text: "Consultation & Eligibility Check — select the most suitable residency route" },
                                { text: "Investment / Company Setup — real estate purchase or business incorporation" },
                                { text: "Application Preparation — residency forms, financial proof, insurance" },
                                { text: "Submission to Civil Registry & Migration Department" },
                                { text: "Approval & Residency Card Issuance — typically 2–4 months (fast track)" }
                            ]
                        }
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Fast Track Residency (Property Investment)",
                                description: "€300,000+ investment",
                            },
                            {
                                name: "Temporary Residence (Pink Slip)",
                                description: "€500+ government fees",
                            },
                            {
                                name: "Business/Investor Residency",
                                description: "€5,000+ setup (company & immigration)",
                            },
                            {
                                name: "Citizenship Pathway",
                                description: "5–7 years residency",
                            },
                        ]}
                    />


                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                { text: "Experts in Cyprus residency & business immigration" },
                                { text: "Guidance on property selection, company setup, and tax residency planning" },
                                { text: "End-to-end support: documentation, application, compliance" },
                                { text: "Advice on Non-Dom tax benefits to maximize savings" }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking to secure EU residency for you and your family?"
                        description="Cyprus offers fast-track residency, business permits, and long-term EU citizenship pathways — combining lifestyle, business opportunities, and tax benefits."
                        buttonText="Book a Cyprus Residency Consultation →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "What is the minimum investment for Cyprus permanent residency?",
        content: [
            { type: "answer", text: "€300,000 in new property." },
        ],
    },
    {
        question: "How fast is the Fast Track Residency process?",
        content: [
            { type: "answer", text: "Usually 2–4 months." },
        ],
    },
    {
        question: "Can I get Cyprus citizenship through investment?",
        content: [
            { type: "answer", text: "Not directly — but after 5–7 years of legal residence, you can apply." },
        ],
    },
    {
        question: "Can residency include family members?",
        content: [
            { type: "answer", text: "Yes — spouse and children (under 25 if dependent)." },
        ],
    },
    {
        question: "Is Cyprus good for digital nomads and entrepreneurs?",
        content: [
            { type: "answer", text: "Yes — Cyprus offers special permits for business owners, fintech founders, and freelancers." },
        ],
    },
];

const testimonialsData = [
    {
        quote: "We secured Cyprus permanent residency through property investment. Offshore Advisory handled the full process, making it simple.",
        author: "Amir S.",
        role: "Investor"
    },
    {
        quote: "As a fintech entrepreneur, I got residency by registering a Cyprus company. Offshore Advisory managed the business and immigration process end-to-end.",
        author: "Laura M.",
        role: "Startup Founder"
    }
];

